import React, { useState, useCallback, useEffect, useRef } from "react";
import { ThemeProvider } from "@mui/material/styles";
import Suggestions from "../Utils/Suggestions";
import { conditionStatus } from "../initialData/initialData";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";
import {
  Autocomplete,
  Grid,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableBody,
  Tooltip,
  Card,
} from "@mui/material";
import dayjs from "dayjs";
import {
  StyledTableCellHistory,
  StyledTableRowHistory,
  StyledTextField,
  StyledMultilineTextField,
  StyledButton,
  StyledDatePicker,
  OutlinedFab,
  theme,
  StyledTableContainer,
  OutlinedIconFab,
} from "../StyledComponents";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import KeyboardVoiceIcon from "@mui/icons-material/KeyboardVoice";
import MicOffIcon from "@mui/icons-material/MicOff";
import ClearIcon from "@mui/icons-material/Clear";

import { toast } from "react-toastify";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import Icon from "../Utils/Icons";
import { ChiefComplaintTable } from "./ChiefComplaintTable";

const ChiefComplaint = React.memo(
  ({
    sectionName,
    activeSection,
    suggestions,
    aiSuggestionToggle,
    ruleSuggestionToggle,
    handleCrossButtonClick,
    data,
    setData,
    startRecording,
    stopRecording,
    isAiEnabled,
  }) => {
    const durationUnits = [
      "minutes",
      "hours",
      "days",
      "weeks",
      "months",
      "years",
    ];
    // console.log("Data from Chief Complaints", data);
    const today = dayjs();
    const [authToken, setAuthToken] = useState(
      sessionStorage.getItem("accessToken") !== undefined &&
        sessionStorage.getItem("accessToken") !== null
        ? sessionStorage.getItem("accessToken")
        : ""
    );
    const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
    const headers = {
      Authorization: `Bearer ${authToken}`,
    };
    const [autocompleteData, setAutoCompleteData] = useState([]);
    const [filteredOptions, setFilteredOptions] = useState([]);
    const [suggestApiCalled, setSuggestApiCalled] = useState(false);
    const [
      debounceFunctionCalledCondition,
      setDebounceFunctionCalledCondition,
    ] = useState(false);
    const { transcript, resetTranscript } = useSpeechRecognition();
    const [listeningOn, setListeningOn] = useState(false);
    const [newCondition, setNewCondition] = useState({
      condition: "",
      id: null,
      clinical_status_description: "",
      duration: "",
      onset_datetime: "",
      abatement_datetime: null,
      clinical_note: "",
    });
    const [durationInputValue, setDurationInputValue] = useState("");
    const [termSelectedOrAdded, setTermSelectedOrAdded] = useState(false);
    const [conditionName, setConditionName] = useState("");
    const [editingIndex, setEditingIndex] = useState(null);
    const [complaints, setComplaints] = useState(data);
    const [isConditionUpdated, setIsConditionUpdated] = useState(false);
    const [isFocused, setIsFocused] = useState(false);
    const [mouseDownOnOption, setMouseDownOnOption] = useState(false);
    const [
      keepSuggestionsVisibleAfterClick,
      setKeepSuggestionsVisibleAfterClick,
    ] = useState(false);
    const [suggestionClicked, setSuggestionClicked] = useState(false);

    const debounceTimeout = useRef(null); // Use useRef to persist timeout
    const skipEffect = useRef(false);
    const optionChosen = useRef(false);
    const inputRef = useRef(null);

    console.log("complaints", complaints);
    useEffect(() => {
      setComplaints(data);
    }, [data]);

    useEffect(() => {
      setAuthToken(sessionStorage.getItem("accessToken"));
    }, [sessionStorage.getItem("accessToken")]);

    const handleConditionTyped = (value) => {
      setConditionName(value);

      // if (debounceTimeout.current) {
      //   clearTimeout(debounceTimeout.current); // Clear previous timeout
      // }

      // debounceTimeout.current = setTimeout(() => {
      //   handleAddOptionContinuously(value); // Only triggers after user stops typing
      // }, 500);
    };
    const handleSuggestionClick = (value) => {
      console.log("value---->", value);
      console.log("conditionName-->", conditionName);
      setConditionName(value);
      setIsConditionUpdated(true);
      setSuggestionClicked(true);
      inputRef.current.focus();
      // setKeepSuggestionsVisibleAfterClick(true); // allow options to remain visible
    };
    // useEffect(() => {
    //   if (isConditionUpdated) {
    //     handleAddOption();
    //     setIsConditionUpdated(false); // Reset flag
    //   }
    // }, [isConditionUpdated]);
    console.log("conditionName-->", conditionName);
    const [validationErrors, setValidationErrors] = useState({
      condition: "",
      clinical_status_description: "",
      duration: "",
      onset_datetime: "",
    });
    useEffect(() => {
      // alert(`DH ${activeHistorySection}`);
      if (activeSection) {
        let timerId;

        timerId = setTimeout(() => {
          setConditionName(transcript);
        }, 3000);

        return () => {
          clearTimeout(timerId);
        };
      }
    }, [transcript]);

    useEffect(() => {
      if (skipEffect.current) {
        skipEffect.current = false; // reset after skipping
        return;
      }

      // Call the API with the debounced function when conditionName changes

      let timerOut = setTimeout(() => {
        if (conditionName.trim() !== "") {
          debouncedConditionFilterCall(conditionName.toLowerCase());
        }
      }, 500);
      return () => clearTimeout(timerOut);
    }, [conditionName]);

    const startListening = (key) => {
      // alert("MH SL");
      if (transcript) {
        resetTranscript();
      }
      // setActiveHistorySection("Family History");
      SpeechRecognition.startListening({ continuous: true, language: "en-IN" });
      setListeningOn(true);
    };
    const debouncedConditionFilterCall = async (medicine) => {
      console.log("Debounce function called");
      let semanticTagForConditionSearch = "finding++disorder";
      const postBody = {
        term: medicine,
        state: "active",
        semantictag: semanticTagForConditionSearch,
        acceptability: "synonyms",
        returnlimit: "100",
        refsetid: null,
        parentid: null,
        excludeparentconcept: false,
        fullconcept: false,
      };

      try {
        if (conditionName.length > 1) {
          const response = await axios.post(
            `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
            postBody,
            { headers: headers }
          );
          if (response) {
            console.log("Snomed Response", response);
            if (
              response.data.status === "Success" &&
              response.data.data.length > 0
            ) {
              const dataToProcess =
                response.data.data.length > 300
                  ? response.data.data.slice(0, 300)
                  : response.data.data;

              const filteredData = dataToProcess.map((medicineItem) => {
                return {
                  term: medicineItem.term,
                  id: medicineItem.conceptId,
                };
              });
              console.log("Filtered Medicine Data", filteredData);
              setAutoCompleteData(filteredData);
              setFilteredOptions(filteredData);
            } else {
              try {
                const response = await axios.post(
                  `${REACT_APP_BACKEND_ROUTE_URL}snomed/suggest/`,
                  postBody,
                  { headers: headers }
                );
                if (response) {
                  console.log("Suggest Response", response);
                  if (
                    response.data.status === "Success" &&
                    response.data.data.length > 0
                  ) {
                    setSuggestApiCalled(true);
                    const dataToProcess =
                      response.data.data.length > 300
                        ? response.data.data.slice(0, 300)
                        : response.data.data;
                    setAutoCompleteData(dataToProcess);
                    setFilteredOptions(dataToProcess);
                    // setSelectedFromSuggestion(true);
                  } else {
                    // setSelectedFromSuggestion(true);

                    setAutoCompleteData([]);
                    setFilteredOptions([]);
                  }
                }
              } catch (err) {
                console.log(err);
                toast.error(err);
              }
            }
            setDebounceFunctionCalledCondition(true);
          }
        }
      } catch (err) {
        console.log(err);
        toast.error(err);
      }
    };
    const validateFields = () => {
      const errors = {};

      if (!newCondition.condition && conditionName.length === 0) {
        errors.condition = "Condition is a mandatory field.";
      }

      if (durationInputValue && !newCondition.duration) {
        errors.duration = "Please select a duration option.";
      }
      // if (!newCondition.onset_datetime) {
      //   errors.onset_datetime = "Start Date is a mandatory field.";
      // }

      setValidationErrors(errors);

      return Object.keys(errors).length === 0; // Return true if no errors
    };
    const calculateOnsetDate = (duration, type) => {
      if (!duration) return null;
      const today = dayjs(); // Current date
      const durationMap = {
        minutes: "minute",
        hours: "hour",
        days: "day",
        weeks: "week",
        months: "month",
        years: "year",
      };
      console.log("date onset", today.subtract(duration, durationMap[type]));
      return today.subtract(duration, durationMap[String(type).toLowerCase()]);
    };
    const getDurationParts = (durationValue) => {
      if (typeof durationValue !== "string" || durationValue.trim() === "") {
        return { duration: "", durationType: "" };
      }
      const parts = durationValue.trim().split(/\s+/);
      const duration = parts[0] || "";
      const durationType = parts[1] || "";
      return { duration, durationType };
    };
    // Function to handle adding a new row
    const handleAddCondition = async () => {
      if (!validateFields()) {
        return; // Exit if validation fails
      }

      console.log("conditionName in addoption-->", conditionName);
      let newDetails,
        newConditionWithDate,
        updatedFound = {},
        updatedSelectedOptiondetsils = {},
        foundData = false;
      console.log("optionChosen", optionChosen.current);
      if (!optionChosen.current) {
        const postBody = {
          term: conditionName,
          state: "active",
          semantictag: "finding++disorder",
          acceptability: "synonyms",
          returnlimit: "100",
          refsetid: null,
          parentid: null,
          excludeparentconcept: false,
          fullconcept: false,
        };

        try {
          if (conditionName.length > 1) {
            const response = await axios.post(
              `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
              postBody,
              { headers: headers }
            );
            if (response) {
              console.log("Snomed Response", response);
              if (
                response.data.status === "Success" &&
                response.data.data.length > 0
              ) {
                foundData = response.data.data.find(
                  (d) => d.term === conditionName
                );
                console.log("Found Data", foundData);
                if (foundData) {
                  updatedFound = {
                    ...foundData,
                    found: true,
                    id: foundData.conceptId,
                  };
                } else {
                  updatedSelectedOptiondetsils = {
                    hierarchy: null,
                    isPreferredTerm: null,
                    conceptState: null,
                    conceptFsn: conditionName,
                    definitionStatus: null,
                    conceptId: null,
                    languageCode: "en",
                    typeId: null,
                    term: conditionName,
                    caseSignificanceId: "CASE_INSENSITIVE",
                    id: null,
                    effectiveTime: null,
                    activeStatus: null,
                    moduleId: null,
                  };
                }
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: conditionName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: conditionName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }

              if (foundData) {
                console.log("updatedFound", updatedFound);
                newDetails = {
                  ...newCondition,
                  condition: updatedFound.term,
                  id: updatedFound.id,
                };
                // handleInputChange("condition", updatedFound);
              } else {
                console.log(
                  "updatedSelectedOptiondetsils",
                  updatedSelectedOptiondetsils
                );
                newDetails = {
                  ...newCondition,
                  condition: updatedSelectedOptiondetsils.term,
                  id: updatedSelectedOptiondetsils.id,
                };
                // handleInputChange("condition", updatedSelectedOptiondetsils);
              }
            } else {
              newDetails = {
                ...newCondition,
                condition: conditionName,
                id: null,
              };
              // handleInputChange("condition", updatedSelectedOptiondetsils);
            }
          }
        } catch (err) {
          console.log(err);
          // toast.error(err);
          newDetails = {
            ...newCondition,
            condition: conditionName,
            id: null,
          };
        }

        console.log("New Details Added", newDetails);
        newConditionWithDate = {
          ...newDetails,
          onset_datetime: newDetails.onset_datetime
            ? dayjs(newDetails.onset_datetime).format("YYYY-MM-DD")
            : null,
        };
      } else {
        console.log("New Condition Added", newCondition);
        newConditionWithDate = {
          ...newCondition,
          onset_datetime: newCondition.onset_datetime
            ? dayjs(newCondition.onset_datetime).format("YYYY-MM-DD")
            : null,
        };
      }

      // Add the new condition to the complaints list
      let updatedDetails = [...complaints, newConditionWithDate];
      setComplaints(updatedDetails);
      setNewCondition({
        ...newConditionWithDate,
        condition: "",
        duration: "",
        clinical_note: "",
      });
      setDurationInputValue("");
      setValidationErrors({}); // Clear errors after successful submission
      setDebounceFunctionCalledCondition(false);
      setTermSelectedOrAdded(false);
      setConditionName("");
      setData(updatedDetails);
      setFilteredOptions([]);
      optionChosen.current = false;
    };

    // Function to handle input changes
    const handleInputChange = (field, value) => {
      let newDetails;
      if (field == "condition") {
        setAutoCompleteData([]);
        setFilteredOptions([]);
        setTermSelectedOrAdded(true);
        newDetails = {
          ...newCondition,
          [field]: value.term,
          id: value.id,
        };
      } else {
        newDetails = {
          ...newCondition,
          [field]: value,
        };
      }
      console.log("Field and value:", field, value);

      if (field === "clinical_status_description") {
        setValidationErrors((prev) => ({
          ...prev,
          clinical_status_description: "",
        }));
        if (!value) {
          newDetails = {
            ...newDetails,
            abatement_datetime: null,
          };
          const wasResolvedLike =
            newCondition.clinical_status_description === "Resolved" ||
            newCondition.clinical_status_description === "Remission";
          if (wasResolvedLike) {
            newDetails = {
              ...newDetails,
              onset_datetime: null,
            };
          }
        }
      }

      // Validation and additional logic
      if (field === "duration") {
        const floatValue = parseFloat(value);
        const intValue = parseInt(value, 10);

        // Validate duration as a positive integer
        if ((floatValue && isNaN(floatValue)) || floatValue <= 0) {
          setValidationErrors((prev) => ({
            ...prev,
            duration: "Duration must be a positive integer",
          }));
        } else if (floatValue && floatValue !== intValue) {
          setValidationErrors((prev) => ({
            ...prev,
            duration: "Duration must be a positive integer",
          }));
        } else {
          setValidationErrors((prev) => ({
            ...prev,
            duration: "",
          }));
        }
      }

      if (field === "duration") {
        const { duration, durationType } = getDurationParts(value);
        const newOnsetDate =
          duration && durationType
            ? calculateOnsetDate(duration, durationType)
            : null;
        newDetails = {
          ...newDetails,
          onset_datetime: newOnsetDate,
        };
      }
      if (field === "onset_datetime") {
        newDetails = {
          ...newDetails,
          duration: "",
        };
        setDurationInputValue("");
      }
      setNewCondition(newDetails);
    };

    // Function to handle row edit
    const handleEditRow = (index) => {
      setConditionName(complaints[index].condition);
      const complaintToEdit = complaints[index];
      const normalizedDuration =
        complaintToEdit.duration && complaintToEdit.durationType
          ? `${complaintToEdit.duration} ${complaintToEdit.durationType}`
          : complaintToEdit.duration || "";
      const { duration } = getDurationParts(normalizedDuration);
      setDurationInputValue(duration);
      setNewCondition({
        ...complaintToEdit,
        duration: normalizedDuration,
        condition: "",
        id: null,
      });
      setEditingIndex(index);
      // handleDeleteRow(index); // Remove the row from the list temporarily
    };
    console.log("Editing Index", editingIndex);
    const handleUpdate = async () => {
      if (!validateFields()) {
        return; // Exit if validation fails
      }
      let newDetails,
        newConditionWithDate,
        updatedFound = {},
        updatedSelectedOptiondetsils = {},
        foundData = false;

      if (!optionChosen.current) {
        const postBody = {
          term: conditionName,
          state: "active",
          semantictag: "finding++disorder",
          acceptability: "synonyms",
          returnlimit: "100",
          refsetid: null,
          parentid: null,
          excludeparentconcept: false,
          fullconcept: false,
        };

        try {
          if (conditionName.length > 1) {
            const response = await axios.post(
              `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
              postBody,
              { headers: headers }
            );
            if (response) {
              console.log("Snomed Response", response);
              if (
                response.data.status === "Success" &&
                response.data.data.length > 0
              ) {
                foundData = response.data.data.find(
                  (d) => d.term === conditionName
                );
                console.log("Found Data", foundData);
                if (foundData) {
                  updatedFound = {
                    ...foundData,
                    found: true,
                    id: foundData.conceptId,
                  };
                } else {
                  updatedSelectedOptiondetsils = {
                    hierarchy: null,
                    isPreferredTerm: null,
                    conceptState: null,
                    conceptFsn: conditionName,
                    definitionStatus: null,
                    conceptId: null,
                    languageCode: "en",
                    typeId: null,
                    term: conditionName,
                    caseSignificanceId: "CASE_INSENSITIVE",
                    id: null,
                    effectiveTime: null,
                    activeStatus: null,
                    moduleId: null,
                  };
                }
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: conditionName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: conditionName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }

              if (foundData) {
                // console.log("updatedFound", updatedFound);
                newDetails = {
                  ...newCondition,
                  condition: updatedFound.term,
                  id: updatedFound.id,
                };
              } else {
                // console.log(
                //   "updatedSelectedOptiondetsils",
                //   updatedSelectedOptiondetsils
                // );
                newDetails = {
                  ...newCondition,
                  condition: updatedSelectedOptiondetsils.term,
                  id: updatedSelectedOptiondetsils.id,
                };
              }
            } else {
              newDetails = {
                ...newCondition,
                condition: conditionName,
                id: null,
              };
            }
          }
        } catch (err) {
          console.log(err);
          // toast.error(err);
          newDetails = {
            ...newCondition,
            condition: conditionName,
            id: null,
          };
        }

        // console.log("New Details Added", newDetails);
        newConditionWithDate = {
          ...newDetails,
          onset_datetime: newDetails.onset_datetime
            ? dayjs(newDetails.onset_datetime).format("YYYY-MM-DD")
            : null,
          source: undefined,
        };
      } else {
        // console.log("New Condition Added", newCondition);
        newConditionWithDate = {
          ...newCondition,
          onset_datetime: newCondition.onset_datetime
            ? dayjs(newCondition.onset_datetime).format("YYYY-MM-DD")
            : null,
          source: undefined,
        };
      }

      let updatedDetails = complaints.map((data, i) =>
        i == editingIndex ? newConditionWithDate : data
      );
      setComplaints(updatedDetails);
      setEditingIndex(null);
      setNewCondition({
        ...newCondition,
        condition: "",
        duration: "",
        clinical_note: "",
      });
      setDurationInputValue("");
      setDebounceFunctionCalledCondition(false);
      setTermSelectedOrAdded(false);
      setConditionName("");
      setData(updatedDetails);
      setFilteredOptions([]);
      optionChosen.current = false;
    };
    // Function to handle row delete
    const handleDeleteRow = (index) => {
      let updatedDetails = complaints.filter((_, i) => i !== index);
      setComplaints(updatedDetails);
      setData(updatedDetails);
    };

    const memoizedHandleCrossButtonClick = useCallback(
      (sectionName, suggestionName, type) => {
        handleCrossButtonClick(sectionName, suggestionName, type);
      },
      [handleCrossButtonClick]
    );
    const handleClearConditionName = () => {
      setValidationErrors({});
      setConditionName("");
      resetTranscript();
      setNewCondition({
        ...newCondition,
        condition: "", // Use computed property name to set the field dynamically
      });
      setFilteredOptions([]);
      setAutoCompleteData([]);
      setDebounceFunctionCalledCondition(false);
      // setMedicineList([])
    };
    const handleAddOption = async () => {
      console.log("conditionName in addoption-->", conditionName);
      if (conditionName.trim().length == 0) {
        const errors = {};
        errors.condition = "You can't add an empty string";
        setValidationErrors(errors);
        return;
      }
      const postBody = {
        term: conditionName,
        state: "active",
        semantictag: "finding++disorder",
        acceptability: "synonyms",
        returnlimit: "100",
        refsetid: null,
        parentid: null,
        excludeparentconcept: false,
        fullconcept: false,
      };

      try {
        if (conditionName.length > 1) {
          const response = await axios.post(
            `${REACT_APP_BACKEND_ROUTE_URL}snomed/search/`,
            postBody,
            { headers: headers }
          );
          if (response) {
            let updatedFound = {},
              updatedSelectedOptiondetsils = {},
              foundData = false;
            console.log("Snomed Response", response);
            if (
              response.data.status === "Success" &&
              response.data.data.length > 0
            ) {
              foundData = response.data.data.find(
                (d) => d.term === conditionName
              );
              console.log("Found Data", foundData);
              if (foundData) {
                updatedFound = {
                  ...foundData,
                  found: true,
                  id: foundData.conceptId,
                };
              } else {
                updatedSelectedOptiondetsils = {
                  hierarchy: null,
                  isPreferredTerm: null,
                  conceptState: null,
                  conceptFsn: conditionName,
                  definitionStatus: null,
                  conceptId: null,
                  languageCode: "en",
                  typeId: null,
                  term: conditionName,
                  caseSignificanceId: "CASE_INSENSITIVE",
                  id: null,
                  effectiveTime: null,
                  activeStatus: null,
                  moduleId: null,
                };
              }
            } else {
              updatedSelectedOptiondetsils = {
                hierarchy: null,
                isPreferredTerm: null,
                conceptState: null,
                conceptFsn: conditionName,
                definitionStatus: null,
                conceptId: null,
                languageCode: "en",
                typeId: null,
                term: conditionName,
                caseSignificanceId: "CASE_INSENSITIVE",
                id: null,
                effectiveTime: null,
                activeStatus: null,
                moduleId: null,
              };
            }

            setAutoCompleteData([]);
            setFilteredOptions([]);
            setSuggestApiCalled(false);
            setDebounceFunctionCalledCondition(true);
            if (foundData) {
              handleInputChange("condition", updatedFound);
            } else {
              handleInputChange("condition", updatedSelectedOptiondetsils);
            }
          }
        }
      } catch (err) {
        console.log(err);
        toast.error(err);
      }
    };
    return (
      <ThemeProvider theme={theme}>
        {activeSection && (
          <Grid item xs={12}>
            <Suggestions
              sectionName={sectionName}
              suggestions={suggestions}
              activeSection={activeSection}
              aiSuggestionToggle={aiSuggestionToggle}
              ruleSuggestionToggle={ruleSuggestionToggle}
              handleCrossButtonClick={memoizedHandleCrossButtonClick}
              handleSuggestionClick={handleSuggestionClick}
            // handleSuggestionClick={setConditionName}
            />
          </Grid>
        )}

        {activeSection && (
          <Card
            sx={{
              borderRadius: "10px",
              boxShadow: "0 4px 4px 0 #C7C7CC inset",
              backgroundColor: "#FFF",
            }}
          >
            <Grid item xs={12} sm={12} md={12}>
              {/* Input Section */}
              <Grid
                container
                spacing={2}
                sx={{
                  marginTop: "5px",
                  padding: "10px",
                }}
              >
                <Grid item xs={12} sm={8} lg={3}>
                  <StyledTextField
                    inputRef={inputRef}
                    value={
                      // newCondition.condition !== ""
                      //   ? newCondition.condition
                      //   :
                      conditionName
                    }
                    onChange={(e) => {
                      // if (!newCondition.condition) {
                      // setConditionName(e.target.value);
                      handleConditionTyped(e.target.value);
                      // }
                    }}
                    onBlur={() => {
                      setTimeout(() => {
                        const shouldClear =
                          !mouseDownOnOption && !suggestionClicked;

                        if (shouldClear) {
                          setIsFocused(false);
                          setFilteredOptions([]);
                          setDebounceFunctionCalledCondition(false);
                          setTermSelectedOrAdded(false);
                        }

                        setMouseDownOnOption(false);
                        setSuggestionClicked(false); // Reset
                      }, 100);
                    }}
                    // onBlur={() => {
                    //   setTimeout(() => {
                    //     // Skip clearing if the user clicked on filteredOption or suggestion
                    //     if (
                    //       !mouseDownOnOption &&
                    //       !keepSuggestionsVisibleAfterClick
                    //     ) {
                    //       setIsFocused(false);
                    //       setFilteredOptions([]);
                    //       setDebounceFunctionCalledCondition(false);
                    //       setTermSelectedOrAdded(false);
                    //     }

                    //     // Reset all flags
                    //     setMouseDownOnOption(false);
                    //     setKeepSuggestionsVisibleAfterClick(false); // 👈 Reset after blur
                    //   }, 100);
                    // }}
                    //============================
                    // onBlur={() => {
                    //   setTimeout(() => {
                    //     if (!mouseDownOnOption) {
                    //       setIsFocused(false);
                    //       setFilteredOptions([]);
                    //       setDebounceFunctionCalledCondition(false);
                    //       setTermSelectedOrAdded(false);
                    //     }
                    //     setMouseDownOnOption(false); // reset always
                    //   }, 100); // give time for click to register
                    // }}
                    onFocus={() => {
                      setIsFocused(true);
                      if (conditionName.trim() !== "") {
                        debouncedConditionFilterCall(
                          conditionName.toLowerCase()
                        ); // re-trigger filtering
                      }
                    }}
                    InputProps={{
                      endAdornment: (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <div style={{ marginRight: "5px" }}>
                            <Tooltip title="Clear">
                              <OutlinedIconFab
                                size="small"
                                variant="contained"
                                onClick={handleClearConditionName}
                              >
                                <Icon name="clearTextField" size={32} />
                              </OutlinedIconFab>
                            </Tooltip>
                          </div>

                          <>
                            {isAiEnabled &&
                              (listeningOn === false ? (
                                <Tooltip title="Start Listening">
                                  <OutlinedIconFab
                                    onClick={() => {
                                      startRecording();
                                      setListeningOn(true);
                                    }}
                                    variant="contained"
                                    size="small"
                                  >
                                    <Icon name="micNotInUse" size={32} />
                                  </OutlinedIconFab>
                                </Tooltip>
                              ) : (
                                <Tooltip title="Stop Listening">
                                  <OutlinedIconFab
                                    onClick={() => {
                                      stopRecording("Chief Complaints");
                                      setListeningOn(false);
                                    }}
                                    variant="outlined"
                                    size="small"
                                  >
                                    <Icon name="micInUse" size={32} />
                                  </OutlinedIconFab>
                                </Tooltip>
                              ))}
                          </>
                        </div>
                      ),
                    }}
                    label="Condition Name"
                    fullWidth
                    error={!!validationErrors.condition} // Highlight field in red if there's an error
                    helperText={validationErrors.condition} // Show error message
                  />
                  {filteredOptions.length > 0 ? (
                    <div
                      style={{
                        backgroundColor: "#f5f5f5",
                        borderRadius: "10px",
                        padding: "20px",
                        maxHeight: "200px", // Set your desired maximum height here
                        overflowY: "auto", // Add vertical scrolling
                      }}
                    >
                      {/* Display filtered medicines */}
                      {suggestApiCalled && (
                        <div style={{ color: "red" }}>
                          No Exact Matches found ! You can search for the
                          following Suggestions.
                        </div>
                      )}

                      <>
                        {filteredOptions.map((op) => (
                          <div key={op}>
                            {
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                {op.added ? (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <StyledButton
                                      color="success"
                                      sx={{
                                        textAlign: "left",
                                        justifyContent: "flex-start",
                                        width: "100%",
                                      }}
                                    >
                                      {op.term}
                                    </StyledButton>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        flexDirection: "row",
                                        color: "green",
                                        fontStyle: "bold",
                                      }}
                                    >
                                      <span>&#10003;</span>
                                      <span>(Added)</span>
                                    </div>
                                  </div>
                                ) : (
                                  <StyledButton
                                    color="grey"
                                    sx={{
                                      textAlign: "left",
                                      justifyContent: "flex-start",
                                      width: "100%",
                                    }}
                                    onClick={() => {
                                      skipEffect.current = true; // prevent debounce call
                                      optionChosen.current = true;
                                      setConditionName(op.term);
                                      handleInputChange("condition", op);
                                    }}
                                    onMouseDown={() =>
                                      setMouseDownOnOption(true)
                                    }
                                  >
                                    {op.term}
                                  </StyledButton>
                                )}
                              </div>
                            }
                          </div>
                        ))}
                      </>
                    </div>
                  ) : filteredOptions.length == 0 &&
                    debounceFunctionCalledCondition &&
                    !termSelectedOrAdded ? (
                    <div
                      style={{
                        backgroundColor: "#f5f5f5",
                        borderRadius: "10px",
                        padding: "20px",
                        maxHeight: "300px", // Set your desired maximum height here
                        overflowY: "auto", // Add vertical scrolling
                      }}
                    >
                      <div style={{ color: "red" }}>No Options Found!</div>
                    </div>
                  ) : null}
                </Grid>
                <Grid item xs={6} sm={4} lg={2}>
                  <Autocomplete
                    options={conditionStatus}
                    value={
                      newCondition.clinical_status_description
                        ? newCondition.clinical_status_description
                        : null
                    }
                    onChange={(_, newValue) =>
                      handleInputChange(
                        "clinical_status_description",
                        newValue ?? ""
                      )
                    }
                    isOptionEqualToValue={(option, value) => option === value}
                    slotProps={{
                      paper: {
                        sx: {
                          "& .MuiAutocomplete-listbox": {
                            fontSize: "12px",
                          },
                        },
                      },
                    }}
                    renderInput={(params) => (
                      <StyledTextField
                        {...params}
                        label="Clinical Status"
                        placeholder="Select clinical status"
                        fullWidth
                        error={!!validationErrors.clinical_status_description}
                        helperText={
                          validationErrors.clinical_status_description || " "
                        }
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={3}>
                  <Autocomplete
                    freeSolo={false}
                    options={
                      durationInputValue
                        ? durationUnits.map(
                            (unit) => `${durationInputValue} ${unit.toUpperCase()}`
                          )
                        : []
                    }
                    value={newCondition.duration || null}
                    inputValue={newCondition.duration || durationInputValue}
                    open={
                      /^\d+$/.test(durationInputValue) &&
                      !newCondition.duration &&
                      durationInputValue.length > 0
                    }
                    onChange={(_, selectedValue) => {
                      if (!selectedValue) return;
                      const numericPart = selectedValue.split(" ")[0] || "";
                      setDurationInputValue(numericPart);
                      handleInputChange("duration", selectedValue);
                    }}
                    onInputChange={(_, value, reason) => {
                      if (reason === "reset") return;
                      if (value === "") {
                        setDurationInputValue("");
                        handleInputChange("duration", "");
                        return;
                      }
                      const numericPrefixMatch = value.match(/^\d+/);
                      if (numericPrefixMatch) {
                        // If user backspaces on a selected value like "8 days",
                        // keep only the numeric part and reopen the unit dropdown.
                        const numericPart = numericPrefixMatch[0];
                        setDurationInputValue(numericPart);
                        handleInputChange("duration", "");
                        return;
                      }
                      if (/^\d+$/.test(value)) {
                        setDurationInputValue(value);
                        handleInputChange("duration", "");
                      }
                    }}
                    renderInput={(params) => (
                      <StyledTextField
                        {...params}
                        label="Duration"
                        fullWidth
                        error={!!validationErrors.duration}
                        helperText={validationErrors.duration}
                      />
                    )}
                  />
                </Grid>
                {(newCondition.clinical_status_description == "Resolved" ||
                  newCondition.clinical_status_description == "Remission") && (
                    <Grid item xs={6} sm={6} md={2}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <StyledDatePicker
                          label="Start Date"
                          format="DD-MM-YYYY"
                          disableFuture
                          onChange={(date) =>
                            handleInputChange("onset_datetime", date)
                          }
                          slotProps={{
                            textField: {
                              error: !!validationErrors.onset_datetime, // Pass the error prop to TextField
                              helperText: validationErrors.onset_datetime, // Display helper text for the error
                            },
                            field: { clearable: true },
                          }}
                          value={
                            newCondition?.onset_datetime
                              ? dayjs(newCondition?.onset_datetime)
                              : null
                          }
                        />
                      </LocalizationProvider>
                    </Grid>
                  )}

                {(newCondition.clinical_status_description == "Resolved" ||
                  newCondition.clinical_status_description == "Remission") && (
                    <Grid item xs={6} sm={6} md={2}>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <StyledDatePicker
                          label="End Date"
                          format="DD-MM-YYYY"
                          onChange={(date) =>
                            handleInputChange("abatement_datetime", date)
                          }
                          slotProps={{
                            field: { clearable: true },
                          }}
                          maxDate={today}
                          value={
                            newCondition?.abatement_datetime
                              ? dayjs(newCondition?.abatement_datetime)
                              : null
                          }
                        />
                      </LocalizationProvider>
                    </Grid>
                  )}

                <Grid item xs={12} sm={12} md={6} lg={8}>
                  <StyledMultilineTextField
                    value={newCondition.clinical_note}
                    onChange={(e) =>
                      handleInputChange("clinical_note", e.target.value)
                    }
                    placeholder="Clinical Notes"
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={3}
                  lg={2}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <StyledButton
                    bgColor="#0E3F66"
                    onClick={
                      editingIndex != null ? handleUpdate : handleAddCondition
                    }
                    variant="contained"
                    sx={{
                      fontSize: { xs: "0.8rem", sm: "1rem" },
                      width: "100%",
                    }}
                  >
                    {editingIndex != null ? "Update" : "Add"}
                  </StyledButton>
                </Grid>
              </Grid>

              {/* Table Section */}
            </Grid>
          </Card>
        )}

        {complaints && (
          <ChiefComplaintTable
            data={complaints}
            activeSection={activeSection}
            handleEditRow={handleEditRow}
            handleDeleteRow={handleDeleteRow}
          />
        )}
      </ThemeProvider>
    );
  }
);

export default ChiefComplaint;
